import { Component, ComponentFactoryResolver, Directive, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { CodigoPerfil } from '../../constants/codigoPerfil';
import { AuthService, UserSigned } from '../../services/auth.service';
import { ControlCalidadContenidoComponent } from '../control-calidad-contenido/control-calidad-contenido.component';
import { DigitalizacionContenidoComponent } from '../digitalizacion-contenido/digitalizacion-contenido.component';
import { FrameboardComponent } from '../frameboard/frameboard.component';
import { MesaPartesFrameboardComponent } from '../mesa-partes-frameboard/mesa-partes-frameboard.component';
import {DespachoFrameboardComponent} from '../despacho-frameboard/despacho-frameboard.component';
import {FrameboardFedatarioComponent} from '../frameboard-fedatario/frameboard-fedatario.component';


@Directive({
  selector: '[templateContent]',
})
export class templateContentDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}

@Component({
  template: '<ng-template templateContent></ng-template>',
})
export class ProfileFrameboardComponent implements OnInit {

  @ViewChild(templateContentDirective, { static: true }) content!: templateContentDirective;

  profileName

  constructor(
    private resolver: ComponentFactoryResolver,
    auth: AuthService
  ) {
    this.profileName = auth.getProfileSelected().codigo
  }

  ngOnInit(): void {
    let componentFactory;

    if (this.profileName === CodigoPerfil.MESA_PARTES) {
        componentFactory = this.resolver.resolveComponentFactory(MesaPartesFrameboardComponent);
    }
    if (this.profileName === CodigoPerfil.DIGITALIZACION) {
        componentFactory = this.resolver.resolveComponentFactory(DigitalizacionContenidoComponent);
    }

    if (this.profileName === CodigoPerfil.USUARIO_FINAL) {
      componentFactory = this.resolver.resolveComponentFactory(FrameboardComponent);
    }

    if (this.profileName === CodigoPerfil.CONTROL_CALIDAD) {
        componentFactory = this.resolver.resolveComponentFactory(ControlCalidadContenidoComponent);
    }

    if (this.profileName === CodigoPerfil.DESPACHO) {
          componentFactory = this.resolver.resolveComponentFactory(DespachoFrameboardComponent);
    }
      if (this.profileName === CodigoPerfil.FEDATARIO) {
          componentFactory = this.resolver.resolveComponentFactory(FrameboardFedatarioComponent);
      }
    const viewContainerRef = this.content.viewContainerRef;
    viewContainerRef.clear();

    if (!componentFactory) {return};
    viewContainerRef.createComponent(componentFactory);
  }
}
